import React, { useContext, useEffect } from "react";
import { BryntumButton } from "@bryntum/schedulerpro-react";
import {VIEW_TYPES} from "../../../other/constants/OtherKeys.jsx";
import BryntumContext, { userPreferences } from "../../context/bryntumContext.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import useViews from "../../hooks/useViews.jsx";
import { getScheduleInstanceFromViewManager } from "../../../other/utils/otherUtils.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { StringHelper } from "@bryntum/schedulerpro";
import { resetSubGrids } from "../../../other/utils/utils.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import AppAddButton from "./headerButtons/appAddButton/AppAddButton.jsx";

const tickSizeLimit = {
  min:  50,
  max:  800,
}


// Todo: add tickSize change listener on scheduler to update the size on header
const SwivuHeaderControlButtons = () => {
  const { viewManager, currentViewRef, user, editorHandler, selectedBoard } = useContext(BryntumContext);
  const viewManagerState = useViews();
  const isSchedulerView = [VIEW_TYPES.schedulerView, VIEW_TYPES.planView].includes(viewManagerState?.selectedView?.viewType);
  const isButtonReadOnly = (user && !user.can(GRANTS.grant_four));
  const canShowButtons = Boolean(user) && Boolean(selectedBoard);



  useEffect(() => {
    if (viewManager && isSchedulerView) {
      viewManager.appHeaderNotifyOnStataChange = (state) => {
        onTickSizeHandler(state?.tickSize)
      }
    }
  }, [viewManager, isSchedulerView]);

  const onMoveTimelineToCurrentDate = () => {
    const reDistributePrefSetting = StringHelper.safeJsonParse(userPreferences.getSetting(PERSISTENCE_STATE_KEYS.redistributeSubGridPanels, true));
    if (reDistributePrefSetting && viewManager.pageViewsRef) {
      resetSubGrids(Object.values(viewManager.pageViewsRef))
    }
    currentViewRef.current.scrollSchedulerTimeAxisToCurrDate()
  }

  const onTickSizeHandler = (value) => {
    const schedulerView = getScheduleInstanceFromViewManager(viewManager);
    if (schedulerView) {
      const tickSize = schedulerView?.tickSize + value;
      if (tickSize < tickSizeLimit.min) {
        schedulerView.tickSize = tickSizeLimit.min;
      } else if (tickSize > tickSizeLimit.max) {
        schedulerView.tickSize = tickSizeLimit.max;
      } else if (tickSize >= tickSizeLimit.min && tickSize <= tickSizeLimit.max) {
        schedulerView.tickSize = tickSize;
        // when changing the tick size we don't want the schedule timeaxis view to shift the view from one date to another
        // to prevent that we need to maintain the last viewport center date
        // See also the onMouseOver listener on Plan and Schedule view where we only update the swivuLastViewportCenterDate once everytime
        if (!currentViewRef.current.swivuLastViewportCenterDate) {
          currentViewRef.current.swivuLastViewportCenterDate = schedulerView.viewportCenterDate;
        }
        // swivuLastViewportCenterDate can still be null if the timeaxis view is hidden due to it be covered from left and right sides of grids
        if (currentViewRef.current.swivuLastViewportCenterDate) {
          schedulerView.scrollToDate(currentViewRef.current.swivuLastViewportCenterDate, { block: "center" });
        }
      }
    }
  }




  return (
    <div className="flex md:justify-end justify-center items-center gap-[1em]">
      {isSchedulerView && (
        <div className="bg-[#CCCCCC] dark:bg-[#242429] px-3 rounded-md flex gap-4 items-center">
          <BryntumButton
            disabled={isButtonReadOnly}
            tooltip="Configure Timeline"
            onClick={() => editorHandler.openEditor(EDITOR_KEYS.timelineConfiguratorEditor, null, {}, { useExisting: true })}
            cls="b-transparent px-0 text-[#0c0a09] dark:text-white min-h-[2.5em]"
            icon="swivu-icon fa-light fa-gear"
          />
          <BryntumButton
            disabled={isButtonReadOnly}
            tooltip="Focus Timeline"
            onClick={onMoveTimelineToCurrentDate}
            cls="b-transparent px-0 text-[#0c0a09] dark:text-white min-h-[2.5em]"
            icon="swivu-icon fa-light fa-crosshairs"
          />
          <BryntumButton
            disabled={isButtonReadOnly}
            tooltip="Decrease Column Width"
            onClick={() => onTickSizeHandler(-50)}
            cls="b-transparent px-0 text-[#0c0a09] dark:text-white min-h-[2.5em]"
            icon="swivu-icon fa-light fa-circle-minus"
          />
          <BryntumButton
            disabled={isButtonReadOnly}
            tooltip="Increase Column Width"
            onClick={() => onTickSizeHandler(50)}
            cls="b-transparent px-0 text-[#0c0a09] dark:text-white min-h-[2.5em]"
            icon="swivu-icon fa-light fa-circle-plus"
          />
        </div>
      )}
      {canShowButtons && (
        <>
          <BryntumButton
            cls="b-transparent !bg-[#CCCCCC] dark:!bg-[#242429] min-h-[auto] h-[2.5em] w-[2.5em] p-0 !rounded-md text-[#0c0a09] dark:text-white"
            icon="b-fa b-fa-search"
            onClick={() => editorHandler.openEditor(EDITOR_KEYS.entityFinder, null, { isOnlyFinder: true }, { by: "recordType", useExisting: true })}
          />
          <AppAddButton />
        </>
      )}
    </div>
  );
};

export default SwivuHeaderControlButtons;
